import { Col, Row } from "antd";
import { FC } from "react";
import LeasingStore from "../../../../contexts/leasingStore";
import { MotorAgencyDataType } from "../../../../types/leasingTypes";
import MotorAgencyHistory from "./motorAgencyHistory";
import MotorAgencyReportCheck from "./motorAgencyReportCheck";
import MotorAgencyReportInfo from "./motorAgencyReportInfo";
import PopoverList from "../../../../components/popups/popoverList";

const MotorAgencyReportView: FC = () => {
  const { leasingCase, adminValues, setAdminValues } = LeasingStore.useContainer();
  const { motorAgency } = adminValues || {};
  const vin = leasingCase.vehicle?.vin;

  const handleNewReport = (motorAgency: MotorAgencyDataType) => {
    adminValues && setAdminValues({ ...adminValues, motorAgency });
  };

  return (
    <>
      <MotorAgencyReportInfo report={motorAgency} />
      <Row justify="space-between">
        <Col>
          <PopoverList list={[
            !leasingCase.id ? "Der er ingen sagsID????" : null,
            !vin ? "Der er intet stelnummer" : null
          ].filter(Boolean) as string[]}>
            <MotorAgencyHistory
              vin={vin}
              disabled={!leasingCase.id || !vin}
              activeMotorAgencyDataId={motorAgency?.id || null}
              leasingCaseId={leasingCase.id}
              onActiveChange={handleNewReport}
            />
          </PopoverList>
        </Col>
        <Col>
          <PopoverList list={[
            !leasingCase.id ? "Der er ingen sagsID????" : null,
            !vin ? "Der er intet stelnummer" : null
          ].filter(Boolean) as string[]}>
            <MotorAgencyReportCheck disabled={!leasingCase.id || !vin} />
          </PopoverList>
        </Col>
      </Row>
    </>
  );
};

export default MotorAgencyReportView;
